import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Description.module.sass";
import Image from "../../../components/Image";
// import { READ_CONTRACT_LINK } from "../../../utils";

const Description = () => {
    return (
        <div className={cn("section-bg", styles.section)}>
            <div className={cn("container", styles.container)}>
                <div className={styles.wrap}>
                    {/*<div className={styles.stage}>Set your own terms</div>*/}
                    <h1 className={cn("h1", styles.title)}>
                        Earn from Liquidations
                    </h1>
                    <div className={styles.text}>
                        Support pools by liquidating loans up to 50% cheaper than the market price
                    </div>
                    <div className={styles.btns}>
                        <Link className={cn("button", styles.button)} to="/pool/0x3f302D860b27FB06C794eE0916abC1D3A362Bf7e">
                            Discover WETH Pool
                        </Link>
                        <Link className={cn("button-stroke", styles.button)} to="/pool/0x85162c81D0Ef84b21230eB4bf3cAb073B71F3c38">
                            Discover USDC Pool
                        </Link>
                    </div>
                </div>
                <div className={styles.gallery}>
                    <div className={styles.preview}>
                        <Image
                            srcSet="/images/content/chart-pic@2x.png 2x"
                            srcSetDark="/images/content/chart-pic@2x.png 2x"
                            src="/images/content/chart-pic.png"
                            srcDark="/images/content/chart-pic.png"
                            alt="LiquidNFTs"
                        />
                        {/*<Image
                            srcSet="/images/content/market-pic@2x.png 2x"
                            srcSetDark="/images/content/market-pic@2x.png 2x"
                            src="/images/content/market-pic.png"
                            srcDark="/images/content/market-pic.png"
                            alt="LiquidNFTs"
                        />*/}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Description;
